import { render, staticRenderFns } from "./UserCircle.vue?vue&type=template&id=3a47b666&scoped=true"
import script from "./UserCircle.vue?vue&type=script&lang=js"
export * from "./UserCircle.vue?vue&type=script&lang=js"
import style0 from "./UserCircle.vue?vue&type=style&index=0&id=3a47b666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a47b666",
  null
  
)

export default component.exports